export default "__VITE_ASSET__847ccda9__"